module.exports = __webpack_public_path__ + "static/media/girlsad.e84c894f.png";